import { useParams } from 'react-router-dom';
import Assessment from '../../components/assessments/Assessment';
export const AssessmentView = () => {
  const { assessmentCategoryType } = useParams();
  return <Assessment assessmentCategoryType={assessmentCategoryType} />;
};
